'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'transitionable',

  props: {
    mode: String,
    origin: String,
    transition: String
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/mixins/transitionable.js
// module id = 196
// module chunks = 5